/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Tier_ConflictInputs */

const vi_error_shop_tier_conflict = /** @type {(inputs: Error_Shop_Tier_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng vừa được người khác sửa cùng lúc. Vui lòng tải lại và lưu lại.`)
};

/**

* @param {Error_Shop_Tier_ConflictInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_tier_conflict = /** @type {((inputs?: Error_Shop_Tier_ConflictInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Tier_ConflictInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_tier_conflict(inputs)
});